import { ArrowBack, Edit } from "@mui/icons-material";
import { Box, Button, Divider, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ISharePanelState, IWatermarkOptions } from "./ShareFileComp";

export interface IShareFileWatermark {
    setSharePanelState: React.Dispatch<React.SetStateAction<ISharePanelState>>
    handleChangeWater: (event: React.ChangeEvent<HTMLInputElement>) => void;
    setWatermarkOptions: React.Dispatch<React.SetStateAction<IWatermarkOptions>>;
    watermarkOptions: IWatermarkOptions;
    watermark: string;
}

export const ShareFileWatermark: React.FC<IShareFileWatermark> = ({
    setSharePanelState,
    handleChangeWater,
    setWatermarkOptions,
    watermarkOptions,
    watermark
}) => {

    const { t } = useTranslation();

    return (
        <Box sx={{ position: 'relative', minHeight: '100%', pb: '72px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button
                    startIcon={<ArrowBack sx={{color: "#22638D"}} />}
                    onClick={e => setSharePanelState({
                        default: true,
                        waterMark: false
                    })}
                >
                    <Typography
                        sx={{
                            textAlign: "left",
                            font: "normal normal normal 10px/14px Segoe UI",
                            letterSpacing: "0px",
                            color: "#22638D",
                            opacity: 1,
                        }}
                    >
                        {t("ShareFileComp.back")}
                    </Typography>
                </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Edit sx={{ mr: 1 }} />
                <Typography sx={{
                    textAlign: "left",
                    font: "normal normal 600 20px/30px Segoe UI",
                    letterSpacing: "0px",
                    color: "#2D2D2D",
                    opacity: 1,
                }} variant="h6">{t("ShareFileComp.editWatermark")}</Typography>
            </Box>

            <Divider sx={{ marginTop: "18px", marginBottom: "24px" }} />

            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                    value={watermark}
                    onChange={handleChangeWater}
                >
                    <FormControlLabel
                    value="1" 
                    control={
                    <Radio
                    sx={{
                        color: "#22638D",
                        "&.Mui-checked": {
                            color: "#22638D"
                        }
                    }} />
                    }
                    label={t("ShareFileComp.noWatermark")} />
                    <FormControlLabel
                    value="2" 
                    control={
                    <Radio 
                    sx={{
                        color: "#22638D",
                        "&.Mui-checked": {
                            color: "#22638D"
                        }
                    }}/>
                    } 
                    label={t("ShareFileComp.text")} />
                </RadioGroup>
            </FormControl>

            <TextField
                fullWidth
                placeholder={t("ShareFileComp.typeHere")}
                variant='standard'
                label={
                    <Typography
                        sx={{
                            textAlign: "left",
                            font: "normal normal normal 12px/18px Segoe UI",
                            letterSpacing: "0px",
                            color: "#2D2D2D",
                            opacity: 1,
                        }}
                    >
                        {t("ShareFileComp.textWord")}
                    </Typography>
                }
                disabled={watermark != "2"}
                sx={{
                    marginBottom: "15px"
                }}
                value={watermarkOptions.text}
                onChange={e => {
                    setWatermarkOptions({
                        ...watermarkOptions,
                        text: e.target.value
                    });
                }}
            />

            <Select
                fullWidth
                placeholder='Selecione'
                variant='standard'
                label={
                    <Typography
                        sx={{
                            textAlign: "left",
                            font: "normal normal normal 12px/18px Segoe UI",
                            letterSpacing: "0px",
                            color: "#2D2D2D",
                            opacity: 1,
                        }}
                    >
                        {t("ShareFileComp.orientation")}
                    </Typography>
                }
                disabled={watermark != "2"}
                value={watermarkOptions.orientation}
                onChange={e => {
                    setWatermarkOptions({
                        ...watermarkOptions,
                        orientation: e.target.value
                    });
                }}
                MenuProps={{
                    disablePortal: true
                }}
            >
                <MenuItem
                    value="horizontal"
                >
                    Horizontal
                </MenuItem>
                <MenuItem
                    value="vertical"
                >
                    Vertical
                </MenuItem>
            </Select>
        </Box>
    )
}